import styled from "styled-components";

export const IconButton = styled.button`
    flex-shrink: 0;
    cursor: pointer;
    appearance: none;
    padding: 0.28em 0.45em;
    font-size: 1.1rem;
    color: #ec454f;
    background: #0001;
    outline: none;
    border: none;
    transition: 100ms;
    border-radius: 0.3em;
    margin: 0.1em;

    &:hover {
        background: #0002;
    }
`;
